import { Injectable } from '@angular/core';
import { TuiTime, TuiValueTransformer } from '@taiga-ui/cdk';

import { fromIsoToTuiTime } from './taiga-ui-date.fns';

/**
 * Transformer converting between an ISO-8601 string and a {@Link TuiTime}.
 *
 * Implements the Taiga UI value transformer interface to integrate with Taiga form controls (InputTime)
 * as internal representation of dates is using {@Link TuiTime}
 */
@Injectable()
export class TimeTransformer implements TuiValueTransformer<TuiTime | null, string> {
  fromControlValue(controlValue: string): TuiTime | null {
    return controlValue ? fromIsoToTuiTime(controlValue) : null;
  }

  toControlValue(day: TuiTime | null): string {
    return day?.toString('HH:MM:SS.MSS') ?? '';
  }
}
